export default "__VITE_PUBLIC_ASSET__f069e5f0__"